import gql from 'graphql-tag'

export const SURVEYS = gql`
  query {
    allSurveys(order: "created_at DESC", where: { import_status: "success" }) {
      id
      name
    }
  }
`

export const SURVEY_FORM = gql`
  query SurveyForm($surveyId: Int!) {
    surveyForm(surveyId: $surveyId) {
      allDimensions {
        id
        name
      }

      topics: allTopics {
        id
        name
        themes: subtopics {
          id
          name
          groups {
            id
            name
          }
        }
      }

      allSectors {
        id
        b3Name
      }
    }

    subtopicsPerSectors(surveyId: $surveyId) {
      sectorId
      tagId
    }
    groupingsPerSectors(surveyId: $surveyId) {
      sectorId
      tagId
    }
    topicsPerSectors(surveyId: $surveyId) {
      sectorId
      tagId
    }
  }
`
